import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import BsyAlertTextEdit from "../BsyAlertTextEdit";
import { BsyUtils } from "../../utils/Utils";
import BsyAlertQrcode from "../BsyAlertQrcode";
import BsyDashContainer from "../dash/BsyDashContainer";//表单-编辑-表单链接

import BsySelect from "../BsySelect";
import DocumentTitle from "react-document-title";
import "./index.css";
import tipAlert from "../../Login/BsyAlertTip/Staticize";
import { BsyConfig } from "../../global/BsyConfig";
import { setPageTitle } from "../../utils/setPageTitle";
class BsyQueryForm extends Component {
  static defaultProps = {
    mode: "teamlink",
  };

  constructor(props) {
    super(props);
    this.state = {
      formType: "form",
      isPassPWD: window.FX.STATIC["HASPWD"],
      isDashFull: false,
      rel: "and",
      dashConfig: {},
      isLoading: true,
      mode: props.mode,
      formAuthGroups: [],
    };
    this.dashView = React.createRef();
    this.$formcontent = React.createRef();
    this.$view = React.createRef();
    this.renderIndex = 0;
  }
  openPWD = () => {
    const { type } = this.state;
    BsyAlertTextEdit({
      title: React.language("query.pass.tip"),
      noCancel: true,
      width: 350,
      onOk: (val, t) => {
        React.axios(`/q/${window.FX.STATIC["QTOKEN"]}/password`, {
          queryPwd: val,
        })
          .then(() => {
            this.setState({ isPassPWD: true }, () => {
              this.loadDashViewData();
              t.closeAlter();
            });
            return true;
          })
          .catch(() => {
            return false;
          });
        return false;
      },
    });
  };

  onfullscreenchange = () => {
    let fullEl = BsyUtils.closestClass(this.dashView.current, "BsyQueryForm");
    if (fullEl) {
      if (!document.fullscreenElement) {
        fullEl.classList.remove("fullScreen");
        fullEl.classList.remove("dash-theme-dark");
        this.setState({
          isDashFull: false,
        });
      }
    }
  };

  componentDidMount() {

    window.FX.STATIC.VIP_PACK = null;
    BsyUtils.Vip._getPack();

    if (!this.state.isPassPWD) {
      this.loadDashViewData();
    } else {
      this.setState({}, () => {
        this.openPWD();
      });
    }
  }

  _getEntryType = () => {
    let t = this.data.entry;
    if (t) {
      let e = "form" === t.type ? (t.hasCoop ? "coop" : "flow") : t.type;
      return e;
    }
  };
  _createHeader = () => {
    let t = this,
      e = this.props,
      i = this.data.entry;
    this.$header = window
      .$('<div className="header"/>')
      .appendTo(window.$(this.$view.current));
    if ("teamlink" === e.mode) {
      this.$header.addClass("team-link-header");
      let n = window.$('<div className="title"/>').appendTo(this.$header);
      let o = "";
      switch (this._getEntryType()) {
        case "coop":
        case "flow":
          o = "icon-bby-form icon-bby-form-" + i.formIcon;
          break;
        case "report":
          o = "icon-bby-report icon-bby-form-" + i.formIcon;
          break;
        case "dash":
        case "scenes":
          o = "icon-bby-dash icon-bby-form-" + i.formIcon;
          break;
        default:
          o = "icon-bby-form icon-bby-form-" + i.formIcon;
      }
      n.prepend(window.$("<i/>").addClass(o));

      let s = window
        .$('<div className="qrcode-btn"/>')
        .append('<i className="icon-qrcode"/>')
        .click(function () {
          window.$(".qrcode-dropdown").remove();
          let t = window.$('<div className="qrcode-dropdown"/>');
          window
            .$("<div id ='qrcode' style='border:solid 10px #fff;' />")
            .appendTo(t);
          window.$("<div/>").text('微信"扫一扫"，分享给好友').appendTo(t);

          window.FX.Msg.bubble({
            anchor: s,
            text4Ok: null,
            text4Cancel: null,
            contentHTML: t,
            minWidth: 150,
            dockPosition: "right",
          });
          //替换 qrcode.min库
        })
        .prependTo(this.$header);
    } else {
      let r = !1,
        o = window.$('<i className="icon-sidebar"/>');
      window
        .$('<div className="sidebar-container"/>')
        .append(
          window
            .$('<div className="icon-container"/>')
            .append(o)
            .on("click", function () {
              r = !r;
              window.$(o).toggleClass("icon-rotate", r);
              window.FX.Utils.applyFunc(t, e.onToggleMenu, [r], !1);
              setTimeout(function () {
                t.content && t.content.doResize(null, !0);
              }, 600);
            })
        )
        .prependTo(this.$header);
    }
  };

  _createContent = () => {
    let t = this.props;
    this.$entryContent = window
      .$('<div className="entry-content"/>')
      .appendTo(window.$(this.$view.current));
    "teamlink" === t.mode && this.$entryContent.addClass("team-link-content");

    let e = this.data.entry;
    switch (e.type) {
      case "form":
        window.FX.STATIC.isSubmit = e.content.isSubmit;
        this._createFormViewSelector(
          window.$.extend({}, e, {
            flowConf: this.data.flow,
          }),
          this.data.authGroups
        );
        break;
      case "report":
        let i = window
          .$('<div className="scroll-layer">')
          .appendTo(this.$entryContent),
          a = e.content;

        this.content = new window.FX.Report(
          window.$.extend(a, {
            renderEl: window
              .$('<div className="report scrollable"/>')
              .appendTo(i),
            appId: e.appId,
            entryId: e.entryId,
            width: "100%",
            height: "100%",
            hasLazyLoad: !0,
          })
        );
        this._setEntryName();
        break;
      default:
    }
  };

  _createFormViewSelector = (t, e) => {
    let a, i, n, s, r, o, l;
    if (window.FX.Utils.isObjectEmpty(e)) {
      this._setEntryName();
      this._createFormView(t);
    } else {
      a = {};
      i = [];
      window.FX.Utils.forEach(e, function (t, e) {
        0 <= e.groupId &&
          i.push({
            text: e.name,
            value: e.groupId,
          });
        a[e.groupId] = e;
      });
      n = [];
      s = t.hasCoop
        ? window.FX.CONST.AUTH_GROUP_CONTENT
        : window.FX.CONST.FLOW_AUTH_GROUP_CONTENT;
      window.FX.Utils.forEach(s, function (t, e) {
        let i = a[e.groupId];
        window.FX.Utils.isNull(i) ||
          n.push({
            text: i.name,
            value: i.groupId,
          });
      });
      r = (i = n.concat(i))[0].value;
      o = window.FX.Store.getKey("authGroup", {
        appId: window.FX.STATIC.APPID,
        entryId: t.entryId,
      });
      l = window.FX.Store.get(o);
      window.FX.Utils.isNull(l) || (a[l] ? (r = l) : window.FX.Store.remove(o));
      i.length <= 1
        ? this._setEntryName()
        : this._createAuthSelect({
          value: r,
          items: i,
          authGroupMap: a,
          attr: t,
          groupIdKey: o,
        });
    }

    // window.FX.Utils.isObjectEmpty(e) ? (this._setEntryName(), this._createFormView(t)) : (a = {},
    //   i = [],
    //   window.FX.Utils.forEach(e, function (t, e) {
    //     0 <= e.groupId && i.push({
    //       text: e.name,
    //       value: e.groupId
    //     }),
    //       a[e.groupId] = e
    //   }),
    //   n = [],
    //   s = t.hasCoop ? window.FX.CONST.AUTH_GROUP_CONTENT : window.FX.CONST.FLOW_AUTH_GROUP_CONTENT,
    //   window.FX.Utils.forEach(s, function (t, e) {
    //     let i = a[e.groupId];
    //     window.FX.Utils.isNull(i) || n.push({
    //       text: i.name,
    //       value: i.groupId
    //     })
    //   }),
    //   r = (i = n.concat(i))[0].value,
    //   o = FX.Store.getKey("authGroup", {
    //     appId: window.FX.STATIC.APPID,
    //     entryId: t.entryId
    //   }),
    //   l = FX.Store.get(o),
    //   window.FX.Utils.isNull(l) || (a[l] ? r = l : FX.Store.remove(o)),
    //   this._setFormView(r, a, t),
    //   i.length <= 1 ? this._setEntryName() : this._createAuthSelect({
    //     value: r,
    //     items: i,
    //     authGroupMap: a,
    //     attr: t,
    //     groupIdKey: o
    //   }))
  };
  _createAuthSelect = (t) => {
    let e = t.items,
      s = t.value,
      r = t.authGroupMap,
      l = t.groupIdKey,
      c = window
        .$('<div className="form-view-selector"/>')
        .on("click", function () {
          let i = window
            .$('<div className="fui-entry-view-bubble"/>')
            .on("click", function (t) {
              let e,
                i = window.$(t.target).closest(".combo-item");
              if (i && i.length && !i.hasClass("select")) {
                i.addClass("select").siblings().removeClass("select");
                e = i.data("item");
                s = e.value;
                a.close();
                d.text(e.text);
                window.FX.Store.set(l, s);
                // s === window.FX.CONST.DEFAULT_AUTH_GROUP && window.FX.Utils.dt(window.FX.CONST.TRACKER.AUTH_GROUP_DEFAULT_VISIT)
              }

              // i && i.length && !i.hasClass("select") && (i.addClass("select").siblings().removeClass("select"),
              //   e = i.data("item"),
              //   s = e.value,
              //   a.close(),
              //   d.text(e.text),
              //   n._setFormView(s, r, o),
              //   FX.Store.set(l, s),
              //   s === window.FX.CONST.DEFAULT_AUTH_GROUP && window.FX.Utils.dt(window.FX.CONST.TRACKER.AUTH_GROUP_DEFAULT_VISIT))
            });
          window.FX.Utils.forEach(e, function (t, e) {
            window
              .$('<div className="combo-item"/>')
              .text(e.text)
              .toggleClass("select", e.value === s)
              .toggleClass(
                "with-separator",
                e.value === window.FX.CONST.DEFAULT_AUTH_GROUP
              )
              .data("item", e)
              .append(
                '<div className="item-icon"><i className="icon-ok"/></div>'
              )
              .appendTo(i);
          });
          let a = window.FX.Msg.bubble({
            anchor: c,
            contentHTML: i,
            minWidth: 240,
            hasTriangle: !1,
            hAdjust: c.outerWidth() / 2 - 6,
            contentPadding: 0,
            text4Cancel: null,
            text4Ok: null,
          });
        })
        .appendTo(this.$header),
      d = window.$('<div className="name-text"/>').text(r[s].name).appendTo(c);
    window
      .$('<div className="icon-wrapper"><i className="icon-angledown"/></div>')
      .appendTo(c);
  };

  _setEntryName = () => {
    let t;
    if (this.$header && this.data && this.data.entry) {
      t = this.data.entry.name;
      this.$header.append(window.$('<div className="entry-name"/>').text(t));
    }
  };

  _createFormView = (a, n) => {
    window.$(this.$formcontent.current).empty();
    this.$entryContent = window
      .$('<div className="entry-content"/>')
      .appendTo(window.$(this.$formcontent.current));

    let s = this,
      t = this.state;
    window.FX.STATIC.ENTRYID = a.entryId;
    window.FX.STATIC.APPID = a.appId;
    let e = {},
      i = !window.FX.Utils.isEmpty(a.flow && a.flow.flowVer);
    if (a.hasFlow && i) {
      e.forward = {
        text: window.FX.Utils.getFlowActionText("forward", a.flow),
      };
      a.flow.allowSave &&
        (e.save = {
          text: window.FX.Utils.getFlowActionText("save", a.flow),
        });
      a.hasFlowPrint &&
        (e.print = {
          text: window.FX.Utils.getFlowActionText("print", a.flow),
        });
    }

    let c = {
      renderEl: window
        .$('<div className="form"/>')
        .appendTo(this.$entryContent.empty()),
      appId: a.appId,
      entryId: a.entryId,
      flows: a.flow,
      hasFlow: a.hasCoop == false && a.hasFlow,
      hasFlowPrint: a.hasFlowPrint,
      printText:
        e.print && e.print.text
          ? e.print.text
          : React.language("flow.action.print"),
      authGroupId: n,
      cacheEnable: t.cacheEnable && a.hasCache,
      updateTime: a.updateTime,
      width: "100%",
      height: "100%",
      hasHeader: !1,
      submitText: React.language("flow.action.forward"),
      hasFooter: a.content
        ? a.content.isSubmit
          ? a.content.isSubmit === "yes"
            ? !0
            : !1
          : !0
        : !0,
      buttonPosition: "left",
      multiTabs: a.formTabs,
      formTabsStyle: a.formTabsStyle || {},
      formEvents: a.formEvents,
      onSuccess: function (t, e, i) {
        if (t && t.error_code) {
          let title = React.language("form.submit.fail.charger");
          let msg = React.language("form.submit.fail.charger.desc");
          if (t.error_code === BsyConfig().CONST.FLOW_FAIL_CODE.FORWARD_COND) {
            title = React.language("form.submit.fail.cond");
            msg = t.error_info; //;
          } else if (
            t.error_code === BsyConfig().CONST.FLOW_FAIL_CODE.FORWARD_SUBFLOW
          ) {
            title = React.language("form.submit.fail.subflow");
            msg = React.language("form.submit.fail.subflow.desc");
          } else if (
            t.error_code === BsyConfig().CONST.FLOW_FAIL_CODE.FORWARD_approval
          ) {
            title = React.language("form.submit.fail.approval");
            msg = React.language("form.submit.fail.approval.desc");
          }
          window.FX.Msg.alert({
            title: title,
            msg: msg,
            type: "warning",
            text4Cancel: null,
            text4Ok: React.language("iSee"),
          });
          return;
        }
        if (i) {
          s._showFormPrint(t.data);
          s.$entryContent.empty();
          window.FX.Utils.showSuccessInfo(c.$entryContent, t, function () {
            // window.FX.STATIC.IS_EVENT ? c._loadContentByAgainAdd(b) : c._createFormView(b);
          });
        } else {
          if (window.FX.Utils.hasHref()) {
            let hasBlank = window.FX.STATIC.FORMHREF.hasBlank;
            let data = window.$.extend(true, {}, arguments[3], t.retdata);
            window.FX.Utils.href(data);
            if (hasBlank) {
              s.$entryContent.empty();
              window.FX.Utils.showSuccessInfo(c.$entryContent, t, function () {
                // window.FX.STATIC.IS_EVENT ? c._loadContentByAgainAdd(b) : c._createFormView(b);
              });
            }
          } else {
            s.$entryContent.empty();
            window.FX.Utils.showSuccessInfo(s.$entryContent, t, function () {
              s._createFormView(a, n);
            });
          }
        }
      },
    };
    "teamlink" === t.mode &&
      window.$.extend(c, {
        width: 1080,
        height: null,
        // buttonPosition: "middle",
        multiTabScrollElement: this.$entryContent,
        onGetScrollContainer: function () {
          return s.$entryContent;
        },
      });
    this.content = new window.FX.Form(window.$.extend({}, a.content, c));
    return this.content;
  };
  _showFormPrint = (t) => {
    let e = window.FX.Utils.createLoadLayer(window.$("body"), {
      isLight: !0,
      isModal: !0,
    });
    new window.FX.FormEditPane({
      renderEl: window.$('<div className="x-shadow-content"/>').appendTo(e),
      height: "100%",
      appId: t.appId,
      dataId: t._id,
      originPrint: "flow",
      entryId: t.entryId,
      flowType: "print",
      flowId: 0,
      hasFlowBtn: !1,
      hasDataLog: !1,
      onCancel: function () {
        e.remove();
      },
    });
  };

  _constructOpt = () => {
    let _this = this;
    const $ = window.$;
    let opt = {
      components: {},
      autoLoad: false,
      // mode: "edit",
      onCheckAllFilter: function (widget, filter) {
        let i = true;
        BsyUtils.forEach(fields, function (a1, b1) {
          let i1 = false;
          BsyUtils.forEach(filter, function (a2, b2) {
            if (b2.field == b1) {
              if (_this.checkFilterValid(b2)) {
                i1 = true;
                return !1;
              }
            }
          });
          if (!i1) {
            i = !1;
            return !1;
          }
        });
        if (!i) {
          _this._showQueryAlert();
        }
        return i;
      },
    };
    let selectIndex = 0;
    let selectWidth = 15;
    let selectHeigh = 6;
    let filterField = $.extend(true, [], this.filterFields);
    let fields = [];
    BsyUtils.forEach(filterField, function (a1, res) {
      res.widgetId = res.name;
      res.height = 6;
      res.width = 15;
      res.posX = (selectIndex % 4) * selectWidth;
      res.posY = parseInt(selectIndex / 4) * selectHeigh;
      res.title = res.text;
      res.changeMethod = !1;
      fields.push(res.name);
      res.fields = [
        {
          field: res.name,
          form: window.FX.STATIC.ENTRYID,
          type: res.type,
          format: res.format,
        },
      ];
      let g = _this._getAttr(res);

      opt.components[g.widgetId] = $.extend(true, {}, g);
      selectIndex++;
    });
    opt.components["filter_btn"] = {
      type: "filter_btn",
      widgetId: "filter_btn",
      height: 6,
      width: 6,
      posX: parseInt(selectIndex % 4) * selectWidth,
      posY: parseInt(selectIndex / 4) * selectHeigh,
    };
    selectIndex++;

    let datatable = {
      widgetId: "datatable",
      widgetNameAlias: "datatable",
      width: 60,
      height: 40,
      entrance: "form",
      posY: Math.ceil(selectIndex / 4) * selectHeigh,
      posX: 0,
      chart_label: { enable: true },
      defaultSort: [],
      url: "/data/formdataload",
      fields: _this.queryFields,
      filter: { cond: [], rel: "and" },
      forms: [window.FX.STATIC.ENTRYID],
      readData: true,
      ptlist: _this.form.ptlist,
      formulas: [],
      hasExport: false,
      itemsPerPage: 20, //默认单页20条，200行，如果字段行过多，会卡死
      // multipleChoice: true,//开启默认多选
      // checkStatus: opt.isSubform ? "check" : "radio",
      metrics: [],
      origin: "dash",
      palette: "preset_1",
      permission: "all",
      type: "data_table",
    };
    opt.components["datatable"] = datatable;
    return opt;
  };

  _getAttr = (c) => {
    switch (c.fields[0].type) {
      case "text":
      case "sn": {
        c.defaultConfig = {
          likeMatch: false,
          value: "",
        };
        c.type = "text_filter";
        c.valueMode = "input";
        c.triggers = ["datatable"];
        c.method = "in";
        break;
      }
      case "number": {
        c.defaultConfig = [];
        c.type = "number_filter";
        c.valueMode = "item";
        c.triggers = ["datatable"];
        c.method = "range";
        break;
      }
      case "datetime": {
        c.defaultConfig = [];
        c.type = "date_filter";
        c.valueMode = "item";
        c.triggers = ["datatable"];
        c.method = "range";
        break;
      }
      case "radiogroup":
      case "combo": {
        c.defaultConfig = {
          hasEmpty: false,
          items: [],
        };
        c.type = "text_filter";
        c.valueMode = "item";
        c.triggers = ["datatable"];
        c.method = "in";
        break;
      }
      case "user": {
        c.defaultConfig = {
          hasEmpty: false,
          items: [],
        };
        c.type = "user_filter";
        c.valueMode = "item";
        c.triggers = ["datatable"];
        c.method = "in";
        break;
      }
      case "address": {
        var type = "address_filter";
        switch (c.fields[0].format) {
          case "pcda":
          case "pcd": {
            type = "address_filter";
            break;
          }
          case "pc": {
            type = "address_city_filter";
            break;
          }
          case "p": {
            type = "address_province_filter";
            break;
          }
          default:
        }

        c.defaultConfig = [];
        c.type = type;
        c.valueMode = "item";
        c.triggers = ["datatable"];
        c.method = "all";
        c.format = c.fields[0].format;
        break;
      }
      default:
    }
    return c;
  };

  checkFilterValid = (t) => {
    var e = window.FX.CONST.FILTER_METHOD;
    switch (t.type) {
      case "user":
        switch (t.method) {
          case e.EP:
          case e.NEP:
            return !1;
          default:
            return (
              !BsyUtils.isObjectEmpty(t.value) ||
              t.hasEmpty ||
              t.hasCurrentUser ||
              t.hasCurrentDept ||
              t.hasCurrentSubDept ||
              t.hasCurrentParDept
            );
        }

      case "combocheck":
        switch (t.method) {
          case e.EP:
          case e.NEP:
            return !1;
          default:
            return !BsyUtils.isObjectEmpty(t.value);
        }
      case "datetime":
      case "number":
        switch (t.method) {
          case e.RG:
            return (
              !BsyUtils.isObjectEmpty(t.value) &&
              (!BsyUtils.isObjectEmpty(t.value[0]) ||
                !BsyUtils.isObjectEmpty(t.value[1]))
            );
          case e.EP:
          case e.NEP:
            return !1;
          default:
            return !BsyUtils.isObjectEmpty(t.value);
        }
      case "address": {
        switch (t.method) {
          case e.ALL:
            return !BsyUtils.isObjectEmpty(t.value);
          default:
            return !BsyUtils.isObjectEmpty(t.value);
        }
      }
      default:
        switch (t.method) {
          case e.IN:
          case e.NIN:
            return !BsyUtils.isObjectEmpty(t.value) || t.hasEmpty;
          case e.EP:
          case e.NEP:
            return !1;
          default:
            return !BsyUtils.isObjectEmpty(t.value);
        }
    }
  };

  loadDashViewData() {
    const c = this;
    let rel = this.state.rel;
    React.axios(
      `/dashboard/app/${window.FX.STATIC.APPID}/form/${window.FX.STATIC.ENTRYID}/query_content`,
      {
        fx_access_token: c.props.match.params.innerlink,
        fx_access_type: "form_public",
      }
    ).then((res) => {
      c.form = res.data;
      c._initFields();
      let bb = c._constructOpt();

      this.setState(
        {
          dashConfig: {
            ...bb,
            appId: window.FX.STATIC.APPID,
            entryId: window.FX.STATIC.ENTRYID,
            hasLazyLoad: !0,
          },
          rel: rel,
          isLoading: false,
        },
        () => {
          // this.autoRefresh();
        }
      );
    });
  }

  _initFields = () => {
    var a = this;
    this.filterFields = [];
    this.queryFields = [];
    BsyUtils.forEach(this.form.fields, function (b, c) {
      var d = a.form.queryFields.indexOf(c.name);
      if (d > -1) {
        var subitems = undefined;
        if (c.type == "subform") {
          subitems = [];
          BsyUtils.forEach(c.items, function (a2, b2) {
            subitems.push({
              // tag:b2.name,
              // form:b2.id,
              detailOnly: b2.type === "linkquery",
              afterSuffix: b2.afterSuffix,
              name: b2.name,
              type: b2.type,
              text: b2.text,
              title: b2.text,
            });
          });
        }

        a.queryFields.push({
          tag: c.name,
          form: c.id,
          name: c.name,
          type: c.type,
          text: c.text,
          regex: c.regex,
          afterSuffix: c.afterSuffix,
          title: c.text,
          items: subitems,
          detailOnly: c.type === "linkquery",
        });
      }

      d = a.form.filterFields.indexOf(c.name);
      d > -1 && a.filterFields.push(c);
    });
  };

  getDashContext = (context) => {
    this.bsyDashContext = context;
  };

  openQrcode = (event) => {
    event.stopPropagation();
    const { dashConfig } = this.state;
    const pot = event.currentTarget.getBoundingClientRect();
    const css =
      160 >
        document.documentElement.clientHeight -
        pot.top +
        event.currentTarget.offsetHeight +
        2
        ? {
          left: pot.left - 160 + "px",
          minWidth: event.currentTarget.offsetWidth,
          bottom: document.documentElement.clientHeight - pot.top + 2 + "px",
        }
        : {
          left: pot.left - 160 + "px",
          minWidth: event.currentTarget.offsetWidth,
          top: pot.top + event.currentTarget.offsetHeight + 2 + "px",
        };
    let theme = "";
    if (
      dashConfig.styles &&
      dashConfig.styles.theme &&
      dashConfig.styles.theme.name
    ) {
      theme = dashConfig.styles.theme.name;
    }
    BsyAlertQrcode({
      value: window.location.href, //value参数为生成二维码的链接
      size: 160, //二维码的宽高尺寸
      css: css,
      theme: theme,
      text: React.language("msg.qrCode"),
      fgColor:
        theme === "preset_style_dark_3" || theme === "preset_style_dark_1"
          ? "#29314c"
          : "#000000",
    });
  };

  onResetRel = (t) => {
    if (this.bsyDashContext && this.bsyDashContext.setRel)
      this.bsyDashContext.setRel(t);
  };

  _showQueryAlert = () => {
    tipAlert({
      type: "warning",
      msg: React.language("query.complete.warning"),
    });
  };

  onResetFilter = () => {
    this.bsyDashContext.ResetFilter();
  };

  checkFilterValid = (t) => {
    var e = window.FX.CONST.FILTER_METHOD;
    switch (t.type) {
      case "user":
        switch (t.method) {
          case e.EP:
          case e.NEP:
            return !1;
          default:
            return (
              !BsyUtils.isObjectEmpty(t.value) ||
              t.hasEmpty ||
              t.hasCurrentUser ||
              t.hasCurrentDept ||
              t.hasCurrentSubDept ||
              t.hasCurrentParDept
            );
        }

      case "combocheck":
        switch (t.method) {
          case e.EP:
          case e.NEP:
            return !1;
          default:
            return !BsyUtils.isObjectEmpty(t.value);
        }
      case "datetime":
      case "number":
        switch (t.method) {
          case e.RG:
            return (
              !BsyUtils.isObjectEmpty(t.value) &&
              (!BsyUtils.isObjectEmpty(t.value[0]) ||
                !BsyUtils.isObjectEmpty(t.value[1]))
            );
          case e.EP:
          case e.NEP:
            return !1;
          default:
            return !BsyUtils.isObjectEmpty(t.value);
        }
      case "address": {
        switch (t.method) {
          case e.ALL:
            return !BsyUtils.isObjectEmpty(t.value);
          default:
            return !BsyUtils.isObjectEmpty(t.value);
        }
      }
      default:
        switch (t.method) {
          case e.IN:
          case e.NIN:
            return !BsyUtils.isObjectEmpty(t.value) || t.hasEmpty;
          case e.EP:
          case e.NEP:
            return !1;
          default:
            return !BsyUtils.isObjectEmpty(t.value);
        }
    }
  };

  renderForm = () => {
    const { isDashFull, rel, dashConfig } = this.state;
    const that = this;
    let theme = "";
    if (
      dashConfig.styles &&
      dashConfig.styles.theme &&
      dashConfig.styles.theme.name
    ) {
      theme = dashConfig.styles.theme.name;
    }
    let rootTokenDashClass =
      "rootTokenDashClass" +
      this.props.match.params.appid +
      this.props.match.params.entryid;
    return (
      <>
        <div className="dashView-header">
          <div className="dashView-name">{window.FX.STATIC.FORMNAME}</div>
          <div className="dashView-funBtn">
            {dashConfig.showFilter ? (
              <>
                <div
                  className="dash-filter-rel"
                  data-tip={
                    rel === "and"
                      ? React.language("reset.filter.and.tip")
                      : React.language("reset.filter.or.tip")
                  }
                  data-place={"bottom"}
                  data-type={window.mode}
                  data-html={true}
                >
                  <BsySelect
                    allowBlank={false}
                    searchable={false}
                    value={rel}
                    theme={theme}
                    items={[
                      { value: "and", text: React.language("filter.rel.and") },
                      { value: "or", text: React.language("filter.rel.or") },
                    ]}
                    onStopEdit={(val) => {
                      that.onResetRel(val);
                    }}
                  />
                </div>
              </>
            ) : (
              ""
            )}
            {dashConfig.cacheFilter ? (
              <>
                <div
                  data-tip={React.language("reset.filter")}
                  data-place={"bottom"}
                  data-type={window.mode}
                  data-html={true}
                  className="dash-filter-reset"
                  onClick={that.onResetFilter}
                >
                  <i className={"icon-async"} />
                  <span>{React.language("richtext.reset")}</span>
                </div>
              </>
            ) : (
              ""
            )}
            <div
              className="form-view Full"
              onMouseEnter={(event) => {
                if (
                  this.bsyDashContext.props.autoRefresh &&
                  this.bsyDashContext.props.autoRefresh &&
                  this.bsyDashContext.props.autoRefresh.enabled
                ) {
                  window.FX.UI.showPopover({
                    position: "bottomLeft",
                    anchor: window.$(event.target),
                    content: window
                      .$("<span/>")
                      .text(React.language("dash.full.autoRefresh.tip")),
                    type: "dark",
                  });
                }
              }}
              onMouseLeave={() => {
                window.FX.UI.closePopover();
              }}
            >
              <i
                className={
                  isDashFull ? "icon-bsy-iconsuoxiao" : "icon-bsy-iconquanping"
                }
              />
              <span>
                {isDashFull
                  ? React.language("exitfullScreen")
                  : React.language("fullScreen")}
              </span>
            </div>
            <div className="view-qrcode" onClick={this.openQrcode}>
              <i className="icon-qrcode"></i>
            </div>
          </div>
        </div>
        <div className="dashView-body" ref={this.dashView}>
          <BsyDashContainer
            // key={`dash${dashConfig.appId}${dashConfig.entryId}`}
            {...dashConfig}
            mode={"dataload"}
            showType="dashView"
            autoLoad={false}
            autoInit={false}
            isDashFull={isDashFull}
            allComponentDash={{
              entry: {
                components: dashConfig.components,
              },
            }}
            rel={rel}
            rootTokenDashclassName={rootTokenDashClass}
            getContext={this.getDashContext}
          />
        </div>
      </>
    );
  };

  render() {
    const { isLoading } = this.state;
    setPageTitle(window.FX.STATIC.FORMNAME);
    return (
      <>
        {!isLoading && (

          <div className="BsyQueryForm" ref={this.$view}>
            {this.renderForm()}
          </div>

        )}
      </>
    );
  }
}

export default withRouter(BsyQueryForm);
